module.exports = __webpack_public_path__ + "static/media/599.702.9182e618.docx";